import { styled } from "styled-components";
import { Card, Paper } from "@mui/material";

export const CustomPieText = styled("text")`
  font-size: 1rem;
  font-weight: 600;
  fill: ${({ theme }) => theme.colors.textColorOpposite};
`;

export const CustomTooltipStyle = styled(Paper)`
  background-color: ${({ theme }) => theme.colors.dashboardHighlightBg} !important;
  p {
    color: white !important;
  }
  padding: 0.7rem;
`;

export const KipCardBannerStyle = styled("div")`
  background-color: ${({ theme }) => theme.colors.dashboardHighlightBg};
  padding: 8px 20px;
  border-radius: 13px;
  display: flex;
  justify-content: space-between;
`;

export const KipCardStyle = styled(Card)`
  .MuiCardContent-root {
    padding: 0;
  }

  svg {
    fill: white;
  }

  .transparent-fill {
    svg {
      fill: transparent;
      stroke: white;
    }
  }
`;

export const KipCardValue = styled("p")`
  font-size: ${({ theme }) => theme.font.xl};
`;

export const KipCardTitle = styled("p")`
  font-size: ${({ theme }) => theme.font.large};
`;

export const AbsoluteZIndexHeader = styled("p")`
  font-size: ${({ theme }) => theme.font.xl};
  position: absolute;
  z-index: 1;
`;

export const CardHeader = styled("p")`
  font-size: ${({ theme }) => theme.font.xl};
  padding: 0.5rem 1rem;
`;

export const CardHeaderText = styled("text")`
  font-size: ${({ theme }) => theme.font.xl};
  color: ${({theme}) => theme.colors.textColor};
`;
